// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AuctionItem } from './auction-item';
import { AuctionPaddleUser } from './auction-paddle-user';
import { InvoiceLine } from './invoice-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AuctionPurchase extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get lineTotal() {
    return this.amount * this.quantity;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  auctionItemId!: number;
  auctionPaddleUserId!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  quantity!: number;
  auctionItem!: AuctionItem;
  auctionPaddleUser!: AuctionPaddleUser;
  invoiceLines!: InvoiceLine[];
}

